
    import { defineComponent } from 'vue'
    import { filterDefault } from '@/helpers/commons/filterHelper'
    import Column from 'primevue/column'
    import DataTable from 'primevue/datatable'
    import Dialog from 'primevue/dialog'
    import metawebAddPhysicalTableDialogDescriptor from './MetawebAddPhysicalTableDialogDescriptor.json'

    export default defineComponent({
        name: 'metaweb-add-physical-table-dialog',
        components: { Column, DataTable, Dialog },
        props: { visible: { type: Boolean }, physicalTables: { type: Array }, propLoading: { type: Boolean }, roles: { type: Array } },
        emits: ['close', 'save'],
        data() {
            return {
                metawebAddPhysicalTableDialogDescriptor,
                rows: [] as any[],
                selectedTables: [] as any[],
                filters: {
                    global: [filterDefault]
                } as Object,
                loading: false
            }
        },
        watch: {
            physicalTables() {
                this.loadTables()
            },
            propLoading() {
                this.setLoading()
            }
        },
        created() {
            this.loadTables()
            this.setLoading()
        },
        methods: {
            loadTables() {
                this.selectedTables = []
                this.rows = this.physicalTables as any[]
            },
            setLoading() {
                this.loading = this.propLoading
            },
            closeDialog() {
                this.selectedTables = []
                this.$emit('close')
            },
            save() {
                this.$emit('save', [...this.selectedTables])
            }
        }
    })
